/**
 * Unauthorized access page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function Unauthorized() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-6xl font-bold text-red-500 mb-4">403</h1>
          <h2 className="text-2xl font-bold text-white mb-2">Access Denied</h2>
          <p className="text-gray-400">
            You don't have permission to access this resource.
          </p>
          {user && (
            <p className="text-sm text-gray-500 mt-2">
              Current role: <span className="capitalize">{user.role}</span>
            </p>
          )}
        </div>
        
        <div className="space-y-4">
          <Link
            to="/dashboard"
            className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors"
          >
            Go to Dashboard
          </Link>
          <div>
            <Link
              to="/"
              className="text-blue-400 hover:text-blue-300 text-sm"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}